import React from 'react'
import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'
import * as mixins from 'view/styles/mixins'
import { iconSet } from 'view/components/icons'
import { isOpenFin } from 'utils'
import { Locale, Translation } from 'locale'
import { TextButton, TextButtonType, MultiButton } from 'view/components/buttons'
import { WindowSelections } from 'store/selection/selectionTypes'
import CopyToClipboard from 'react-copy-to-clipboard'
import { logService } from 'services'

interface ErrorScreenProdProps {
  message: string
  stack: string
  selections: WindowSelections
  closeApp?: boolean
  onClose?: () => unknown
}

const ErrorScreenWrapper = styled.div`
  ${mixins.flexCenterContent};
  flex-direction: column;
  width: 100%;
  height: 100%;
`

const ErrorHeader = styled.div`
  ${mixins.flexCenterContentCrossAxis};
  flex-direction: row-reverse;
  padding: 0 20px;
  height: 38px;
  width: 100%;
  font-family: NEXWeb;
  font-weight: ${constants.FontWeight.Medium};
  font-size: 15px;
  background-color: black;
  color: white;
  border-top-right-radius: ${constants.panelBorderRadius};
  border-top-left-radius: ${constants.panelBorderRadius};
  border: 1px solid #333;
`

const CloseButton = styled(MultiButton)`
  ${mixins.flexCenterContent};
  width: 20px;
  height: 20px;
  color: #ccc;
  cursor: pointer;

  &:hover {
    color: white;
  }
  svg {
    width: 12px;
  }
`

const Content = styled.div`
  ${mixins.flexCenterContent};
  width: 100%;
  height: 100%;
  border-radius: ${constants.panelBorderRadius};
  flex-direction: column;
  background-color: white;
  font-family: NEXWeb;
  font-weight: ${constants.FontWeight.Medium};
  font-size: 20px;
  padding: 20px;
  svg {
    width: 50px;
    height: 50px;
  }
`

const ButtonGroup = styled.div<any>`
  padding: 20px;
  display: flex;
  justify-content: space-between;

  ${TextButton} {
    margin: 0 5px;
  }
`

class ErrorScreenProd extends React.Component<ErrorScreenProdProps> {
  render() {
    return (
      <ErrorScreenWrapper>
        {this.renderTitleBar()}
        <Content>
          {iconSet.alertIcon}
          {Locale.translate(Translation.SC_ERROR_CAUGHT)}
          {this.renderButtons()}
        </Content>
      </ErrorScreenWrapper>
    )
  }

  private renderButtons = () => (
    <ButtonGroup>
      {this.renderLogButton()}
      {this.renderCloseAppButton()}
    </ButtonGroup>
  )

  private renderLogButton = () => (
    <CopyToClipboard text={this.getFormattedLogs()}>
      <TextButton type={TextButtonType.Primary} onClick={this.handleSaveLogs}>
        {Locale.translate(Translation.TC_BUTTON_DOWNLOAD_LOGS)}
      </TextButton>
    </CopyToClipboard>
  )

  private renderCloseAppButton = () =>
    this.props.closeApp ? (
      <TextButton type={TextButtonType.Tertiary} onClick={this.closeApp}>
        {Locale.translate(Translation.TC_BUTTON_CLOSE_APPLICATION)}
      </TextButton>
    ) : null

  private renderTitleBar = () => {
    const { onClose } = this.props

    return onClose ? (
      <ErrorHeader>
        <CloseButton onClick={onClose} dataTestId="ErrorScreenProd-CloseButton">
          {iconSet.crossIcon}
        </CloseButton>
      </ErrorHeader>
    ) : null
  }

  private getFormattedLogs = () => {
    const { message, stack, selections } = this.props
    return logService.formatLogs(message, stack, selections)
  }

  private handleSaveLogs = () => logService.downloadLogs(this.getFormattedLogs())

  private closeApp = () => (isOpenFin() ? fin.desktop.Window.getCurrent().close() : window.close())
}

export default ErrorScreenProd
